/**
 * Queue a successful login event via the dataLayer in a decoupled manner.
 */
export function sendSuccessfulLoginEvent() {
  try {
    // Check if the dataLayer is available
    if (!(window as any).hasOwnProperty("dataLayer")) {
      (window as any).dataLayer = [];
    }

    const untypedWindow: any = window;

    if (
      untypedWindow.hasOwnProperty("dataLayer") &&
      untypedWindow["dataLayer"] &&
      Array.isArray(untypedWindow["dataLayer"])
    ) {
      untypedWindow.dataLayer.push({
        event: "gaEvent",
        event_name: "login",
        login: {
          event_category: "login",
          event_action: "login_success",
        },
      });
    }
  } catch (_) {
    // We don't want to handle a possible exception => fire and forget
  }
}
